import React from "react";

// Components
import Cookies from 'universal-cookie';
import getCorso from "../../services/getCorso";
import getValutazioniCorso from "../../services/getValutazioniCorso";
import getEsami from "../../services/getEsami";
import getStudenti from "../../services/getStudenti";
import moment from 'moment';
import { PDFViewer, Page, Text, View, Document, StyleSheet, Image } from '@react-pdf/renderer';
import translateString from "../../utils/Locales";

let t = translateString;

export default class PDfFullCourse extends React.Component {

  constructor(props){
    super (props)
    this.state = {
      exams: [], 
      mainAverages: [],
      isReadyToShow: false
    };
  }

  async componentDidMount(){

    const cookies = new Cookies();
    const username = cookies.get('username', { path: '/' });
    const token = cookies.get('token', { path: '/' });
    const currentCorso = cookies.get('currentCourse', { path: '/' });

    this.corso = await getCorso(username, token, currentCorso);
    this.valutazioni = await getValutazioniCorso(username, token, this.corso.id);
    this.esami = await getEsami(username, token, this.corso.id);
    this.studenti = await getStudenti(username, token);
    this.studenti = this.studenti.filter(s => s.corsi.includes(this.corso.id+";") && !s.corsi_ritiro.includes(this.corso.id+';'));
    this.logoUrl = window.sessionStorage.getItem('logo');

    var mainAverages = [];
    var averages = [];
    var ind = 0;

    this.studenti.sort((s1, s2) => { return (s1.cognome).localeCompare(s2.cognome) });

    this.studenti.forEach((studente) => {

        const esamiStudente = this.valutazioni.filter((esame) => esame.id_studente == studente.id && esame.valutazione != -1)
        var gradeSum = 0;
        esamiStudente.forEach((esame) => gradeSum += parseFloat(esame.valutazione));

        var nota = [];
        nota.push(studente.cognome.toUpperCase() + ' ' + studente.nome.toUpperCase());
        nota.push((esamiStudente.lenght == 0 || gradeSum == 0) ? 'N/A' : (gradeSum / esamiStudente.length).toFixed(2));
        averages.push(nota);
        if (averages.length == 15 || ind == this.studenti.length - 1) {
          mainAverages.push(averages);
          averages = [];
        }
        ind++;
    });

    this.setState({ averages: averages, isReadyToShow: true, mainAverages: mainAverages, totalPages: mainAverages.length });
  }

  render () {

    const timeNow = moment().format('yyyy-MM-DD HH:mm:ss'); 

    return (
        <div style={{width: '100%', height: '100%'}} key={Math.random()} > 
        { this.state.isReadyToShow && (
            <PDFViewer style={{width: '100%', height: '100%'}}>
                <Document>
                    { this.state.mainAverages.map((gruppo, index) => {
                        if (index == 0) {

                          return (
                              <Page size="A4" style={{ paddingTop: 80, paddingBottom: 50 }} orientation="portrait" wrap>
                                  <View style={{ marginTop: -60, height: '100%' }}>
                                  <Image style={{position: 'absolute', top: 30, left: 40, width: 'auto', height: 80}} src={this.logoUrl ? this.logoUrl : require('../../images/icon.png')} />
                                  <Text style={{position: 'absolute', top: 45, right: 30, fontSize: 12, width: '100%', textAlign: 'right', color: '#999999'}}>{timeNow}</Text>
                                  <Text style={{margin: 10, fontSize: 20, width: '100%', textAlign: 'center', marginTop: '100px'}}>{t('valutazioni_medie')}</Text>
                                  <Text style={{fontSize: 20, marginLeft: 10, marginRight: 10, width: '100%', maxHeight: 100, textAlign: 'center', marginTop: '5px', color: '#999999', paddingHorizontal: 40}}>{this.corso.name.replace(/\\/g, '')}</Text>
                                  <View style={styles.page} >
                                        <View style={styles.row}>
                                              <View style={{...styles.columnLeft, textAlign: 'center'}}><Text>{t('studente').toUpperCase()}</Text></View>
                                              <View style={{...styles.columnRight, textAlign: 'center'}}><Text>{t('media')}</Text></View>
                                        </View>
                                        { gruppo.map((media) => {
                
                                            return(
                                              <View key={Math.random()} style={{...styles.row, marginTop: -1}}>
                                                  <View style={styles.columnLeft}><Text style={{alignItems: 'center', flex:1}}>{media[0]}</Text></View>
                                                  <View style={styles.columnRight}><Text style={{alignItems: 'center', flex:1}}>{media[1]}</Text></View>
                                              </View>
                                            );
                                        })}
                                      </View>
                                  </View>
                                  <View style={{ position: 'absolute', bottom: 50, left: 0, width: '100%', backgroundColor: '#FFFFFF', textAlign: 'right' }}><Text style={{fontWeight: 'light', fontSize: 9, color: '#BDBDBD', marginRight: 50}}>{t('pagina')} {index + 1} {t('di')} {this.state.totalPages}</Text></View>
                              </Page>
                          );
                        } else {

                          return (
                            <Page size="A4" style={{ paddingTop: 80, paddingBottom: 50 }} orientation="portrait" wrap>
                                  <View style={{ marginTop: -20, height: '100%' }}>
                                  <View style={styles.page} >
                                        <View style={styles.row}>
                                              <View style={{...styles.columnLeft, textAlign: 'center'}}><Text>STUDENTE</Text></View>
                                              <View style={{...styles.columnRight, textAlign: 'center'}}><Text>MEDIA</Text></View>
                                        </View>
                                        { gruppo.map((media) => {
                
                                            return(
                                              <View key={Math.random()} style={{...styles.row, marginTop: -1}}>
                                                  <View style={styles.columnLeft}><Text style={{alignItems: 'center', flex:1}}>{media[0]}</Text></View>
                                                  <View style={styles.columnRight}><Text style={{alignItems: 'center', flex:1}}>{media[1]}</Text></View>
                                              </View>
                                            );
                                        })}
                                    </View>
                                </View>
                                <View style={{ position: 'absolute', bottom: 50, left: 0, width: '100%', backgroundColor: '#FFFFFF', textAlign: 'right' }}><Text style={{fontWeight: 'light', fontSize: 9, color: '#BDBDBD', marginRight: 50}}>Pagina {index + 1} di {this.state.totalPages}</Text></View>
                            </Page>
                          );
                        }
                    })}
                    
                </Document>
            </PDFViewer> 
        )}
        </div>
    );
  }
}

const styles = StyleSheet.create({
  
  row: {
    flexDirection: 'row',
    display: 'flex',
    border:'1 solid #000',
    width: '90%',
    marginLeft: '5%', 
    minHeight: '30px'
  },

  page: {
    fontSize: 10,
    backgroundColor: '#ffffff',
    padding: 10, 
    marginTop: '20px'
  },

  columnLeft: {
    flexDirection: 'column',
    width: '50%',
    borderRight: '1 solid #000', 
    textAlign: 'left', 
    paddingHorizontal: 30, 
    paddingVertical: 10, 
    flex: 1
  }, 

  columnRight: {
    flexDirection: 'column',
    textAlign: 'center', 
    paddingHorizontal: 30, 
    paddingVertical: 10, 
    flex: 1
  }

});
